import { render, staticRenderFns } from "./CpuUsageChart.vue?vue&type=template&id=145e33ea&scoped=true&"
import script from "./CpuUsageChart.vue?vue&type=script&lang=js&"
export * from "./CpuUsageChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145e33ea",
  null
  
)

export default component.exports